import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { loadSentry } from "@/utils/analytics/sentryLoader";
import { getCookieConsent } from "@/components/CookieConsentBanner";
import { initToken } from "@/utils/tokenManager";
import { installGlobalFetchInterceptor } from "@/utils/apiFetch";

// Initialize secure token manager (loads persisted token into memory)
initToken();

// P1-B Phase 2: patch window.fetch once so every existing API call gets
// silent refresh-on-401 (via the HttpOnly mifp_rt cookie) without touching
// each of the 134 call sites individually.
installGlobalFetchInterceptor();

// Sentry — GDPR-compliant default-deny. Only loads if the user has previously
// accepted cookies. On a fresh visit Sentry stays OFF until the banner is
// accepted; CookieConsentBanner.applyConsent(true) will then loadSentry().
const previousConsent = getCookieConsent();
if (previousConsent?.accepted === true) {
  loadSentry();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
